export const DEFAULT_MESSAGES = {
    CONFIRM_CIERRA_FORM: 'Se va a cerrar el formulario ¿Continuar?',
    CONFIRM_ELIMINA_REGISTRO: 'Se va a eliminar el registro ¿Continuar?',
    CONFIRM_GUARDA_REGISTRO: msg => `¿Está seguro de ${msg} el registro?`,
    REGISTRO_ACTUALIZADO: 'El registro se ha actualizado correctamente.',
    REGISTRO_GUARDADO: 'El registro se ha guardado correctamente.',
    REGISTRO_ELIMINADO: 'El registro se ha eliminado correctamente.',
    REGISTRO_AGREGADO: 'El registro se agregó correctamente.',
    DESCARGA_EXCEL: 'Ha iniciado la exportación de archivo Excel, por favor espere',
    SIN_PERMISOS_MATRIZ: 'No tiene permisos para realizar acciones en esta opción',
    SIN_PERMISOS_MENU: 'No tiene permisos para acceder a esta opción.'
  };
  